import { useDispatch } from 'react-redux';
import { APP_ROUTES } from '../../constants/app-routes';
import {
  openLoginModal,
  openVendorRegisterModal,
  openVenueRegisterModal,
} from '../../core/home/action';
import { openNotificationModal } from '../../core/notifications/action';
import { clearSession } from '../../utils/auth/session';

export function useMenuOptions({ areNewNotifications }) {
  const dispatch = useDispatch();

  const openNotificationsModal = () => {
    dispatch(openNotificationModal());
  };

  const logout = () => {
    // This timeout gives time to the drawer to close, and it feels more responsive to the user
    setTimeout(() => {
      clearSession({ signOutCognito: true });
    }, 100);
  };

  const authenticatedMenuOptions = [
    {
      id: 'profile',
      name: 'Profile',
      route: APP_ROUTES.VENDOR_PROFILE,
    },
    {
      id: 'notifications',
      name: 'Notifications',
      onClick: openNotificationsModal,
      accent: areNewNotifications,
    },
    {
      id: 'reviews',
      name: 'Reviews',
      route: APP_ROUTES.REVIEWS,
    },
    {
      id: 'logout',
      name: 'Logout',
      onClick: logout,
    },
  ];

  const unauthenticatedMenuOptions = [
    {
      id: 'login',
      name: 'Login',
      onClick: () => dispatch(openLoginModal()),
    },
    {
      id: 'join_venue',
      name: 'Join as a Venue',
      onClick: () => dispatch(openVenueRegisterModal()),
    },
    {
      id: 'join_vendor',
      name: 'Join as a Vendor',
      onClick: () => dispatch(openVendorRegisterModal()),
    },
  ];

  return {
    authenticatedMenuOptions,
    unauthenticatedMenuOptions,
  };
}
